// extracted by mini-css-extract-plugin
module.exports = {"radio":"Radios_radio__29CL-","block":"Radios_block__3e24B","input":"Radios_input__27qlc","label":"Radios_label__fdoHL"};